import { Link } from 'gatsby';
import { IS_PRO } from 'gatsby-theme-hem-store/src/constants';
import { useCustomer } from 'gatsby-theme-hem-store/src/hooks/useCustomer';
import { useHasMounted } from 'hem-hooks';
import { Text, TextVariant } from 'hem-ui';
import { User } from 'lucide-react';
import React from 'react';

import { displayName } from './Navbar.module.scss';

export const LoginLink = (): JSX.Element => {
  const hasMounted = useHasMounted();
  const customer = useCustomer((state) => state.customer);

  if (!IS_PRO) {
    return (
      <Link
        to="/hem-pro"
        className="text-black transition-colors hover:text-black-600"
        data-selector="Navigation account button"
      >
        <User size={20} />
        <span className="sr-only">Log in</span>
      </Link>
    );
  }

  if (!hasMounted) {
    return (
      <Link
        to="/login"
        className="text-black transition-colors hover:text-black-600"
        data-selector="Navigation account button"
      >
        <User size={20} />
        <span className="sr-only">Log in</span>
      </Link>
    );
  }

  if (customer) {
    return (
      <Link
        to="/account"
        title="View account profile"
        className="text-black transition-colors hover:text-black-600"
        data-selector="Navigation account button"
      >
        <User size={20} />
        <Text variant={TextVariant.BODY_SMALL} className={displayName}>
          {customer.displayName}
        </Text>
      </Link>
    );
  }

  return (
    <Link
      to="/login"
      state={{ from: location.pathname }}
      data-selector="Navigation account button"
      className="text-black transition-colors hover:text-black-600"
    >
      <User size={20} />
      <span className="sr-only">Log in</span>
    </Link>
  );
};
